/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import { Button, Card, Tooltip, Icon, Modal, Col, Spin, Popconfirm, Pagination } from "antd";
import KdsBonItem from "./KdsBonItem";
import { Row } from "antd/es/grid";
import moment from "moment";

type Props = {
    kdsData: Object,
    noDataText: String,
    sendAPI: Function,
    setJson: Function,
    data: Object,
    height: Number,
}

class KdsCheckerView extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            viewBonimList: null,
            load: true,
            lastRender: null,

            pageNum: 1,
        };

        this.loop1 = null;
        this.counterRefresh = 0;

        this.id = "KDS_CHECKER_VIEW";
        this.bon_id = "KDS_BON_OWNER_VIEW";

        this.api = {
            get: "get_kds_checker_view",
            get_bon: "get_kds_checker_bon_view",
            get_all: "get_kds_checker_all_view",
            update_status: "update_status_external_orders_force",
            set_ready: "set_ready_status_all_owner",
        }

        this.selectors = [
            { id: 'BONIM_TAGS', api: 'get_tags_from_type_2' },
        ];

        if (props.data[this.id] === undefined) props.data[this.id] = { data: [] };
        if (props.data[this.bon_id] === undefined) props.data[this.bon_id] = { owner: {}, bon: {}, bonData: [] };

        this.selectors.forEach(x => {
            if (props.data[x.id] === undefined) props.data[x.id] = { dataset: [] };
        });

    }

    componentDidMount() {
        this.getDataApi();
        this.loopRefresh();

        this.props.sendAPI(this.selectors[0].api, '', (obj) => {
            let dataset = obj.data ? obj.data.split('\r').map(x => {
                let y = x.split('\f');
                return { code: y[0], name: y[1] }
            }) : []

            this.props.setJson(this.selectors[0].id, { dataset });
        });
    }

    componentWillUnmount() {
        clearTimeout(this.loop1);
    }

    loopRefresh = () => {

        this.setState({ lastRender: new Date() }, () => {

            let refreshTime = parseInt(this.props.kdsData.sRefreshTime);

            this.counterRefresh++;

            if (refreshTime <= this.counterRefresh) {
                this.getDataApi();
                this.counterRefresh = 0;
            }

            if (this.state.load) {
                let he = new RegExp(/[א-ת]/)
                if (he.test(this.props.getText(15878))) this.setState({ load: false })
            }

            this.loop1 = setTimeout(this.loopRefresh, 1000);
        })
    }

    getDataApi = () => {
        this.props.sendAPI(this.api.get, '_id\r' + this.props.kdsData.sID, (obj) => {
            let data = []
            if (obj.data) {
                data = obj.data.split('\r').map(x => {
                    let y = x.split('\f');
                    return {
                        oID: y[0],
                        oNumber: y[1],
                        oTimeStart: y[2],
                        oTimeEnd: y[3],
                        oTimeOver: y[4],
                        oMethod: y[5],
                        oMethodsDesc: y[6],
                        oSupplierId: y[7],
                        oSupplierName: y[8],
                        _finishBons: y[9] ? y[9].split(',') : [],
                        _notFinishBons: y[10] ? y[10].split(',') : [],
                        oRemarks: y[11],
                        oSupplierLogo: y[12],
                        oCustName: y[13],
                        _countFireBons: y[14],
                    }
                })
            }

            this.props.setJson(this.id, { data });


            if (this.props.data[this.bon_id].owner.oNumber) {
                let owner = data.find(f => f.oNumber === this.props.data[this.bon_id].owner.oNumber);
                let list = this.getBonimList(owner, (e) => {

                    console.log('bonimList', e)
                });

                let bonColor = list.find(f => f.id === this.props.data[this.bon_id].bon.code)
                this.getBonData(owner, { ...this.props.data[this.bon_id].bon, ...bonColor });
            }

            if (this.props.data[this.bon_id].owner.oID && [3, 4].find(f => f == this.props.kdsData.sZoomEnable)) {
                this.getAllData(this.props.data[this.bon_id].owner)
            }

        });

    }

    getBonimList = (owner, next) => {
        if (owner) {

            let res = owner._finishBons.map(x => { return { id: x, _finish: true } });

            owner._notFinishBons.forEach(x => {
                let findItem = res.findIndex(f => f.id === x);
                if (findItem > -1) {
                    res[findItem] = { ...res[findItem], _notFinish: true }
                } else {
                    res.push({ id: x, _notFinish: true })
                }
            });

            if (next) next({ res, owner })

            return res.map(x => {
                // if (x._finish && x._notFinish) return { id: x.id, color: 'yellow' }
                // else
                if (x._finish && !x._notFinish) return { id: x.id, color: '#E2F0D9'/* 'lawngreen' */ }
                else if (!x._finish && x._notFinish) return { id: x.id, color: '#FFF2CC'/*'pink'*/ }
                else return { id: x.id, color: '#DEEBF7' }
            })
        } else {
            return []
        }


        // let greenBons = owner._finishBons.filter(f => !owner._notFinishBons.find(ff => ff === f));
        // let redBons = owner._notFinishBons.filter(f => !owner._finishBons.find(ff => ff === f));
        // let greenLightBons = owner._notFinishBons.filter(f => owner._finishBons.find(ff => ff === f));

        // return [
        //     ...redBons.map(x => { return { id: x, color: 'pink' } }),
        //     ...greenLightBons.map(x => { return { id: x, color: 'yellow' } }),
        //     ...greenBons.map(x => { return { id: x, color: 'lawngreen' } }),
        // ];

    }

    bonimTags = (owner) => {
        // let greenBons = owner._finishBons.filter(f => !owner._notFinishBons.find(ff => ff === f));
        // let redBons = owner._notFinishBons.filter(f => !owner._finishBons.find(ff => ff === f));
        // let greenLightBons = owner._notFinishBons.filter(f => owner._finishBons.find(ff => ff === f));

        // let list = [
        //     ...redBons.map(x => { return { id: x, color: 'pink' } }),
        //     ...greenLightBons.map(x => { return { id: x, color: 'yellow' } }),
        //     ...greenBons.map(x => { return { id: x, color: 'lawngreen' } }),
        // ];
        if (this.state.viewBonimList == owner) {

            let list = this.getBonimList(owner);
            return list.map(x => {
                let tagData = this.props.data[this.selectors[0].id].dataset.find(f => f.code === x.id);
                if (!tagData) tagData = { code: '0', name: this.props.getText(15895) }
                tagData = { ...tagData, color: x.color }
                return (<Button
                    size={'large'}
                    style={{ background: x.color, margin: 2, fontSize: 20 }}
                    onClick={() => { this.getBonData(owner, tagData) }}>
                    {tagData.name}
                </Button>)
            });
        } else {
            return []
        }
    }

    timeFormatHHmm = (time) => {
        return time ? time.split(':').slice(0, -1).join(':') : ''
    }

    getBonData = (owner, bon) => {
        if (owner && parseInt(this.props.kdsData.sZoomEnable)) {
            this.props.sendAPI(this.api.get_bon, 'oID\fbID\r' + owner.oID + '\f' + bon.code, (obj) => {
                if (obj.data) {
                    let data = obj.data.split('\r').map(x => {
                        let y = x.split('\f');
                        return {
                            id: y[0],
                            itemCode: y[1],
                            itemName: y[2],
                            qty: y[3],
                            readyStatus: y[4],
                            title: y[5],
                            group: y[6],
                            groupTitle: y[7],
                            remarks: y[8]
                        }
                    });
                    this.props.setJson(this.bon_id, { owner, bon, bonData: data })
                }
            })
        }
    }

    getAllData = (owner) => {
        if (owner && parseInt(this.props.kdsData.sZoomEnable)) {
            this.props.sendAPI(this.api.get_all, 'oID\r' + owner.oID, (obj) => {
                if (obj.data) {
                    let data = obj.data.split('\r').map(x => {
                        let y = x.split('\f');
                        return {
                            id: y[0],
                            itemCode: y[1],
                            itemName: y[2],
                            qty: y[3],
                            readyStatus: y[4],
                            title: y[5],
                            group: y[6],
                            groupTitle: y[7],
                            remarks: y[8],
                        }
                    });
                    this.props.setJson(this.bon_id, { owner, bon: { code: '-1' }, bonData: data })
                }
            })
        }
    }

    imgUrl = (x) => {
        let origin = window.location.origin;
        // const isDev = origin == 'http://147.235.163.248' || origin == 'http://localhost:3000'
        // const baseUrl = isDev ? "http://147.235.163.248" : origin
        let baseUrl = origin == 'http://localhost:3000' ? "https://devcashontab.co.il" : origin;
        return baseUrl + "/uploads/shared/" + x;
    }

    timeCalc = (hour, type) => {
        const target = moment(hour, "HH:mm:ss");
        const now = moment();
        let diff = moment.duration(type == -1 ? target.diff(now) : now.diff(target));
        let isMinus = diff.asMilliseconds() < 0
        if (isMinus) diff = moment.duration(Math.abs(diff));

        const hh = String(diff.hours()).padStart(2, '0');
        const mm = String(diff.minutes()).padStart(2, '0');
        const ss = String(diff.seconds()).padStart(2, '0');

        return (<p style={{ color: isMinus ? "red" : "auto" }}>
            {this.props.getText(type == -1 ? 21498 : 21497)} &nbsp;&nbsp;
            <span dir="ltr">{`${isMinus ? '-' : ''}${hh}:${mm}:${ss}`}</span>
        </p>);

    }

    setReadyStatusAll = (oID, oReadyStatus, oldStatus) => {
        this.props.sendAPI(this.api.set_ready, `_status\f_ownerId\f_oldStatus\r${oReadyStatus}\f${oID}\f${oldStatus ?? ""}`, () => {

            this.getDataApi()

        }
        )
    }

    render() {
        if (this.state.load) return (<Spin />)

        let gt = this.props.getText;

        // let cardWidth = this.props.height / 2;
        let cardWidth = (window.innerWidth / (this.props.kdsData.sCountRows ?? 4)) * 0.9;

        const divStyle = {
            height: this.props.height,
            overflowY: 'auto',
        }

        document.body.style.overflow = this.props.data[this.bon_id].bon.code ? "hidden" : "auto";

        let cardStyle = {
            borderRadius: 15,
            padding: cardWidth * 0.02,
            fontSize: cardWidth * 0.06,
            textAlign: 'center',
        }
        let divCardStyle = {
            display: 'inline-block',
            verticalAlign: 'text-top',
            margin: cardWidth * 0.05,
            maxHeight: cardWidth * 3,
            width: window.innerWidth <= 600 ? "90%" : cardWidth,
            overflowY: "auto"
        }
        let titleStyle = {
            fontSize: cardWidth * 0.1,
            borderRadius: 5,
            padding: 2,
        }

        let cardActions = x => {
            let res = [
                <Tooltip title={gt(15897)}>
                    <Button className={"btn"} size={'large'} style={{ margin: 2 }} onClick={this.getDataApi}>
                        <Icon type='reload' style={{ fontSize: 16 }} />
                    </Button>
                </Tooltip>,
                <Tooltip title={gt(21501)}>
                    <Button className={"btn"} size={'large'} style={{ margin: 2 }} onClick={() => {
                        this.setState({
                            confirmOn: (<Card
                                title={this.props.getText(21536) + " " + x.oNumber}
                                style={{ textAlign: "center" }}
                                actions={[
                                    <Button onClick={() => { this.setState({ confirmOn: null }) }}>{this.props.getText(21535)}</Button>,
                                    <Button type="primary" onClick={() => { this.setState({ confirmOn: null }, () => { this.setReadyStatusAll(x.oID, 1, 0) }) }}>{this.props.getText(21534)}</Button>,
                                ]}>
                                <h2>{this.props.getText(21533)}</h2>
                            </Card>)
                        }, () => {

                            // Modal.confirm({
                            //     visible: this.state.confirmOn,
                            //     content: (<Card
                            //         title={this.props.getText(21536) + " " + x.oNumber}
                            //         style={{ textAlign: "center" }}
                            //         actions={[
                            //             <Button onClick={() => { this.setState({ confirmOn: false }) }}>{this.props.getText(21535)}</Button>,
                            //             <Button type="primary" onClick={() => { this.setState({ confirmOn: false }, () => { this.setReadyStatusAll(x.oID, 1, 0) }) }}>{this.props.getText(21534)}</Button>,
                            //         ]}>
                            //         <h2>{this.props.getText(21533)}</h2>
                            //     </Card>),
                            //     okButtonProps: { style: { display: "none" } },
                            //     cancelButtonProps: { style: { display: "none" } },
                            //     onOk() { },
                            //     onCancel() { },
                            // })
                        })
                    }}>
                        <Icon type='fire' style={{ fontSize: 16 }} />
                    </Button>
                </Tooltip>,
                <Tooltip title={gt(15896)}>

                    <Button className={"btn"} size={'large'} style={{ margin: 1 }} onClick={() => {
                        this.setState({
                            confirmOn: (<Card
                                title={this.props.getText(21536) + " " + x.oNumber}
                                style={{ textAlign: "center" }}
                                actions={[
                                    <Button onClick={() => { this.setState({ confirmOn: null }) }}>{this.props.getText(21535)}</Button>,
                                    <Button type="primary" onClick={() => {
                                        this.setState({ confirmOn: null }, () => {
                                            let dataSend = 'eStatus\feOwnerId\r' + this.props.kdsData.sStatusListLeft + '\f' + x.oID;
                                            this.props.sendAPI(this.api.update_status, dataSend, () => { this.setReadyStatusAll(x.oID, 2) })
                                        })
                                    }}>{this.props.getText(21534)}</Button>,
                                ]}>
                                <h2>{this.props.getText(21532)}</h2>
                            </Card>)
                        }, () => {

                            // Modal.confirm({
                            //     visible: this.state.confirmOn,
                            //     content: (<Card
                            //         title={this.props.getText(21536) + " " + x.oNumber}
                            //         style={{ textAlign: "center" }}
                            //         actions={[
                            //             <Button onClick={() => { this.setState({ confirmOn: false }) }}>{this.props.getText(21535)}</Button>,
                            //             <Button type="primary" onClick={() => {
                            //                 this.setState({ confirmOn: false }, () => {
                            //                     let dataSend = 'eStatus\feOwnerId\r' + this.props.kdsData.sStatusListLeft + '\f' + x.oID;
                            //                     this.props.sendAPI(this.api.update_status, dataSend, () => { this.setReadyStatusAll(x.oID, 2) })
                            //                 })
                            //             }}>{this.props.getText(21534)}</Button>,
                            //         ]}>
                            //         <h2>{this.props.getText(21532)}</h2>
                            //     </Card>),
                            //     okButtonProps: { style: { display: "none" } },
                            //     cancelButtonProps: { style: { display: "none" } },
                            //     onOk() { },
                            //     onCancel() { },
                            // })
                        })
                    }}>
                        <Icon type='check' style={{ fontSize: 16 }} />
                    </Button>
                </Tooltip>,
            ]

            if (parseInt(this.props.kdsData.sZoomEnable)) {
                res = [
                    <Tooltip title={this.props.getText(20087)}>
                        <Button className={"btn"} size={'large'} style={{ margin: 2 }} onClick={() => {
                            if (this.props.data[this.bon_id].owner.oID == x.oID && [3, 4].find(f => f == this.props.kdsData.sZoomEnable)) {
                                this.props.setJson(this.bon_id, { owner: {}, bon: {}, bonData: [] })
                            } else {
                                this.getAllData(x)
                            }
                        }}>
                            <Icon type='eye' style={{ fontSize: 16 }} />
                        </Button>
                    </Tooltip>,
                    ...res
                ]
            }

            return res
        }

        const { data } = this.props.data[this.id]
        let pageSize = (this.props.kdsData.sCountRows ?? 4) * 2
        let fromIndex = pageSize * (this.state.pageNum - 1)
        let toIndex = pageSize * this.state.pageNum
        let dataFilter = data.length > pageSize ? data.slice(fromIndex, toIndex) : data
        if (this.props.data[this.bon_id].owner.oID && [3, 4].find(f => f == this.props.kdsData.sZoomEnable)) {
            let findO = dataFilter.findIndex(f => f.oID == this.props.data[this.bon_id].owner.oID)
            if (findO < (pageSize / 2)) toIndex -= (pageSize / 2)
            else fromIndex += (pageSize / 2)
            dataFilter = data.slice(fromIndex, toIndex)
        }


        return (<>
            {data.length > 8 ?
                <div style={{ textAlign: "center", direction: "ltr" }}>
                    <Pagination
                        current={this.state.pageNum}
                        total={data.length}
                        pageSize={(this.props.kdsData.sCountRows ?? 4) * 2}
                        onChange={p => { this.setState({ pageNum: p }) }}
                    />
                </div> : ""}
            <div style={divStyle} >
                {
                    dataFilter.length ?
                        dataFilter.map(x => {
                            // let color = !x._notFinishBons.length ? 'lawngreen' : 'pink';
                            let color = !x._notFinishBons.length && !parseInt(x._countFireBons) ? '#E2F0D9'// 'lawngreen'
                                : !x._finishBons.length && !parseInt(x._countFireBons) ? '#FFF2CC'//'yellow' //'#FAEBD7'
                                    : '#DEEBF7'//'lightblue'
                            return (<div style={divCardStyle}>
                                <Card
                                    className="KDS_checker_card"
                                    style={{ ...cardStyle, background: color }}
                                    // onClick={() => {
                                    //     if (parseInt(this.props.kdsData.sZoomEnable)) this.setState({ modalOwner: x.oID })
                                    // }}
                                    actions={cardActions(x)}
                                >
                                    {/**
                        <h1 style={{ ...titleStyle, background: color }}>{gt(15889)}: {x.oNumber}</h1>
                        <Row>
                            <Col span={window.innerWidth > 600 ? 12 : 24}><p>{gt(15890)}: {this.timeFormatHHmm(x.oTimeStart)}</p></Col>
                            <Col span={window.innerWidth > 600 ? 12 : 24}><p>{gt(15891)}: {this.timeFormatHHmm(x.oTimeEnd)}</p></Col>
                            <Col span={window.innerWidth > 600 ? 12 : 24}><p>{gt(15893)}: {x.oSupplierName}</p></Col>
                            <Col span={window.innerWidth > 600 ? 12 : 24}><p>{gt(15892)}: {x.oMethodsDesc}</p></Col>
                        </Row>
                        <p><b>{gt(15894)}: {this.timeFormatHHmm(x.oTimeOver)}</b></p>
                        {x.oRemarks}
                        {this.bonimTags(x)}

                         */}
                                    <Row style={{ minHeight: cardWidth * 0.28 }}>
                                        <Col span={18} style={{ textAlign: "right" }} >
                                            <b>{x.oMethodsDesc} {x.oNumber}</b>
                                            <h2 style={{ fontSize: x.oCustName?.length > 15 ? cardWidth * 0.06 : "auto" }}>{x.oCustName}</h2>
                                        </Col>
                                        <Col span={6}><img height={70} src={this.imgUrl(x.oSupplierLogo)} /></Col>
                                    </Row>
                                    <Row style={{ lineHeight: 0.7 }}>
                                        <Col span={12} style={{ textAlign: "right" }}><p>{gt(21495)} &nbsp;&nbsp;&nbsp; {this.timeFormatHHmm(x.oTimeStart)}</p></Col>
                                        <Col span={12} style={{ textAlign: "left" }}><p>{gt(21496)} &nbsp;&nbsp; {this.timeFormatHHmm(x.oTimeEnd)}</p></Col>
                                        <Col span={12} style={{ textAlign: "right" }}>{this.timeCalc(x.oTimeStart, 1)}</Col>
                                        <Col span={12} style={{ textAlign: "left" }}>{this.timeCalc(x.oTimeEnd, -1)}</Col>
                                    </Row>

                                    {x.oRemarks}




                                </Card>
                                {[3, 4].find(f => f == this.props.kdsData.sZoomEnable) && this.props.data[this.bon_id].owner.oID == x.oID ? (
                                    <KdsBonItem
                                        {...this.props}
                                        {...this.props.data[this.bon_id]}
                                        isFromChecker
                                        cardWidth={window.innerWidth > 600 ? cardWidth : window.innerWidth * 0.9}
                                        closeModal={() => { this.props.setJson(this.bon_id, { owner: {}, bon: {}, bonData: [] }) }}
                                        handleChange={() => {
                                            // this.getBonData(this.props.data[this.bon_id].owner, this.props.data[this.bon_id].bon);
                                            let owner = this.props.data[this.id].data.find(f => f.oNumber === this.props.data[this.bon_id].owner.oNumber);
                                            this.getAllData(owner);
                                            this.getDataApi();
                                        }}
                                        getDataApi={this.getDataApi}
                                    />
                                ) : ''}

                            </div>)
                        }) :
                        (<div style={{ height: cardWidth }}>
                            {this.props.getText(15878)}
                        </div>)
                }
                {[1, 2].find(f => f == this.props.kdsData.sZoomEnable) && this.props.data[this.bon_id].bon.code ? (
                    <KdsBonItem
                        {...this.props}
                        {...this.props.data[this.bon_id]}
                        isModalZoom
                        isFromChecker
                        cardWidth={window.innerWidth > 600 ? window.innerWidth / 2.5 : window.innerWidth * 0.9}
                        closeModal={() => { this.props.setJson(this.bon_id, { owner: {}, bon: {}, bonData: [] }) }}
                        handleChange={() => {
                            // this.getBonData(this.props.data[this.bon_id].owner, this.props.data[this.bon_id].bon);
                            let owner = this.props.data[this.id].data.find(f => f.oNumber === this.props.data[this.bon_id].owner.oNumber);
                            this.getAllData(owner);
                            this.getDataApi();
                        }}
                        getDataApi={this.getDataApi}
                    />
                ) : ''
                }

                <Modal
                    visible={this.state.confirmOn != null}
                    onCancel={() => { this.setState({ confirmOn: null }) }}
                    footer={false}
                >{this.state.confirmOn}</Modal>
            </div >
        </>)
    }
}

export default KdsCheckerView;